<div class="wrapper">
  <router-outlet></router-outlet>
  <app-footer *ngIf="showFooter"></app-footer>
  <ngx-scrolltop></ngx-scrolltop>
</div>